import axios from '@/axios'

const actions = {
  // Cache por evento: não rebusca se a lista do mesmo event_id já está carregada.
  // { force: true } ignora o cache; as mutações abaixo invalidam (robotsEventId=undefined).
  setRobots: ({ commit, dispatch, state }, { event_id, force } = {}) => {
    if (!force && state.robotsEventId === event_id && state.robots.length) {
      return Promise.resolve()
    }
    dispatch('main/setLoading', true, { root: true })
    return axios
      .robots
      .fetch(
        { event_id }
      )
      .then((response) => {
        commit('robots', response)
        commit('robotsEventId', event_id)
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },
  setCreateRobot: ({ dispatch, commit }, robot) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .robots
      .post
      .create(robot)
      .then((response) => {
        commit('robotsEventId', undefined) // invalida o cache da lista
        dispatch('main/setLoading', false, { root: true })
        return response // [{ id, createdat }] — usado p/ encadear upload de foto
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setUpdateRobot: ({ dispatch, commit }, robot) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .robots
      .post
      .update(robot)
      .then((response) => {
        commit('robotsEventId', undefined) // dados do robô mudaram → invalida cache
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setRobotInspection: ({ dispatch, commit }, robot) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .robots
      .post
      .inspection(robot)
      .then((response) => {
        commit('robotsEventId', undefined) // status de inspeção mudou → invalida o cache
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },
  // Devolve true em sucesso e null em falha, para a tela poder AVISAR. Antes
  // resolvia igual nos dois casos, e um upload recusado (sessão expirada, foto
  // grande, sem permissão) passava em silêncio: o inspetor achava que a foto
  // tinha sido salva.
  setRobotImage: ({ dispatch }, robot) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .robots
      .post
      .image(robot)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return true
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setCurrentRobot: ({ commit, dispatch }, robot) =>
    commit('currentRobot', robot),

  // Checklist de inspeção: itens + o que já foi marcado para este robô no evento.
  // Sem spinner global — a tela de inspeção mostra o próprio estado de carga.
  fetchInspectionChecklist: (context, info) => {
    return axios
      .robots
      .post
      .getInspectionChecklist(info)
      .then((response) => response || null)
      .catch(function (error) {
        console.log('-----------error-----------', error)
        return null
      })
  },

  // Marca um item. O backend recalcula a aprovação das duas fases e devolve o
  // estado novo; devolve null se falhou, para a tela reverter o clique.
  // Sem spinner global: isto roda a cada clique no checklist.
  setInspectionCheck: ({ commit }, info) => {
    return axios
      .robots
      .post
      .setInspectionCheck(info)
      .then((response) => {
        commit('robotsEventId', undefined) // aprovação pode ter mudado → invalida o cache
        return response || null
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        return null
      })
  },

  // imagem do robô carregada sob demanda (fora de /get_robots) p/ a tela de detalhe
  fetchRobotImage: (context, robotId) => {
    return axios
      .robots
      .post
      .getImage({ robot_id: robotId })
      .then((response) => (response && response.image) || '')
      .catch(function (error) {
        console.log('-----------error-----------', error)
        return ''
      })
  },

  setEventRobotCount: ({ commit, dispatch }, info) => {
    return axios
      .robots
      .post
      .getEventRobots(info)
      .then((response) => {
        const total = (response && response[0]) ? response[0].total : 0
        commit('eventRobotCount', total)
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
      })
  },
  // retorna a lista de robôs sem sobrescrever o estado compartilhado getRobots
  fetchRobotsList: (context, { event_id } = {}) => {
    return axios
      .robots
      .fetch({ event_id })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        return []
      })
  },
  setRegisterEventRobots: ({ dispatch, commit }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .robots
      .post
      .registerEventRobots(info)
      .then((response) => {
        commit('robotsEventId', undefined) // inscrições mudaram → invalida o cache
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  }
}

export default actions
